const query = typeof location !== 'undefined' ? decodeURI(location.search) : '';
export const defaultLocale =
    (query.match(/[?&]debug[%5B\[]locale[%5D\]]=([^&?]+)/) || [])[1] || 'ru';
// tslint:disable-next-line:no-default-export (autogenerated)
export default defaultLocale;
